module.exports = __webpack_public_path__ + "static/media/editGreen.d7db43c9.svg";